import { favouritesApi } from "./api";

const KEY = "foinn_favourites";

const hash = (s) => {
  let h = 0;
  for (let i = 0; i < (s || "").length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h).toString(36);
};

// A favourite is a snapshot: a tune version, optionally edited/transposed.
export const favKey = (tuneId, version, edited, abc) =>
  `${tuneId}-v${version}${edited ? "-e" + hash(abc) : ""}`;

export const getFavourites = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
};

const write = (f) => {
  localStorage.setItem(KEY, JSON.stringify(f));
  window.dispatchEvent(new Event("fav-changed"));
};

// backend sync is on only while a user is signed in
let backendEnabled = false;
export const setBackendSync = (v) => {
  backendEnabled = v;
};

export const isFavourite = (key) => getFavourites().some((f) => f.key === key);
export const getFavourite = (key) => getFavourites().find((f) => f.key === key);

// every saved snapshot of a tune, newest first
export const favouritesForTune = (tuneId) =>
  getFavourites()
    .filter((f) => String(f.tune_id) === String(tuneId))
    .sort((a, b) => String(b.created_at || "").localeCompare(String(a.created_at || "")));

export const toggleFavourite = (fav) => {
  let favs = getFavourites();
  const exists = favs.some((f) => f.key === fav.key);
  if (exists) {
    favs = favs.filter((f) => f.key !== fav.key);
    if (backendEnabled) favouritesApi.remove(fav.key).catch(() => {});
  } else {
    favs = [{ ...fav, created_at: fav.created_at || new Date().toISOString() }, ...favs];
    if (backendEnabled) favouritesApi.add(fav).catch(() => {});
  }
  write(favs);
  return favs;
};

export const removeFavourite = (key) => {
  if (backendEnabled) favouritesApi.remove(key).catch(() => {});
  write(getFavourites().filter((f) => f.key !== key));
};

// On sign-in: pull server favourites, merge with local, push local-only up.
export const syncFromBackend = async () => {
  const local = getFavourites();
  let server = [];
  try {
    server = (await favouritesApi.list()).favourites || [];
  } catch {
    return;
  }
  const serverKeys = new Set(server.map((f) => f.key));
  await Promise.all(
    local.filter((f) => !serverKeys.has(f.key)).map((f) => favouritesApi.add(f).catch(() => {}))
  );
  const byKey = {};
  [...server, ...local].forEach((f) => {
    byKey[f.key] = { ...byKey[f.key], ...f };
  });
  write(Object.values(byKey));
};

// On sign-out: clear the local cache (keeps other users' favourites private).
export const clearLocal = () => write([]);
